<!--
 * @Author: LiuMeiYu
 * @Date: 2023-01-09 09:15:57
 * @LastEditors: LiuMeiYu
 * @LastEditTime: 2023-05-24 14:14:01
 * @FilePath: \CardSwap\src\views\login\loginView.vue
 * @Description: *
 * *
 * Copyright (c) 2023 by yihua, All Rights Reserved.
-->
<template>
  <div class="login-container" v-loading="loginLoading">
    <div class="header-container">
      <div class="header-content">
        <div class="header-logo">
          <router-link to="/home">
            CardSwap
          </router-link>
        </div>
        <div class="header-menu">
          <div class="header-menu-item">
            <!-- <el-dropdown trigger="click">
              <span class="el-dropdown-link">
                About Us<el-icon class="el-icon--right"><arrow-down /></el-icon>
              </span>
              <template #dropdown>
                <el-dropdown-menu>
                  
                </el-dropdown-menu>
              </template>
            </el-dropdown> -->
          </div>
        </div>
        <div class="header-login-register">
          <div class="header-btn-login">Log in</div>
          <router-link to="/register">
            <div class="header-btn-register">Register</div>
          </router-link>
        </div>
      </div>
    </div>
    <div class="login-content">
      <el-form
        class="login-form"
        label-position="top"
        label-width="100px"
        :model="loginForm"
      >
        <el-form-item label="Your Phone or Email">
          <el-input
            ref="loginAccountRef"
            v-model="loginForm.account"
            autofocus
            placeholder="Please enter your email address"
            @keyup.enter="userLogin"
          />
        </el-form-item>
        <el-form-item label="Your Password">
          <el-input
            ref="loginPasswordRef"
            v-model="loginForm.password"
            type="password"
            show-password
            placeholder="Please input a password"
            @keyup.enter="userLogin"
          />
        </el-form-item>
      </el-form>
      <div class="forgot-password">
        <router-link to="/forgotpassword">Forgot password?</router-link>
      </div>
      <el-button class="login-btn-login" @click="userLogin">Log in</el-button>
      <div class="login-register">
        Not registered yet?
        <span><router-link to="/register">Register Now</router-link></span>
      </div>
    </div>
  </div>
</template>

<script>
import {
  defineComponent,
  reactive,
  onMounted,
  toRefs,
  ref,
  nextTick,
} from "@vue/runtime-core";
import FingerprintJS from "@fingerprintjs/fingerprintjs";
import { userLoginApi } from "../../api/index";
import { ElNotification } from "element-plus";
import { useStore } from "vuex";
import { useRouter } from "vue-router";

export default defineComponent({
  name: "Login",
  components: {},
  setup() {
    onMounted(() => {
      getDeviceNo();
    });
    const state = reactive({
      loginForm: {
        account: localStorage.getItem("userName") || "",
        password: "",
      },
    });
    const router = useRouter();
    const store = useStore();
    const loginLoading = ref(false);
    // 获取唯一标识
    const getDeviceNo = () => {
      FingerprintJS.load().then((fp) => {
        fp.get().then((result) => {
          const visitorId = result.visitorId;
          console.log("设备号:", visitorId);
          localStorage.setItem("device_no", visitorId);
        });
      });
    };
    const loginAccountRef = ref(null);
    const loginPasswordRef = ref(null);
    // 86313663@qq.com 654321 周杰
    const userLogin = () => {
      if (state.loginForm.account) {
        if (state.loginForm.password) {
          loginLoading.value = true;
          let data = {
            username: state.loginForm.account,
            password: state.loginForm.password,
          };
          userLoginApi(data).then((res) => {
            console.log("userLoginApi:", res);
            if (res.data.success) {
              loginLoading.value = false;
              ElNotification({
                title: "Tips",
                message: "Login Success",
                type: "success",
              });

              localStorage.setItem("userName", state.loginForm.account);
              if (res.data.data.token) {
                localStorage.setItem("token", res.data.data.token);
              }
              if (res.data.data.country_id) {
                localStorage.setItem("country_id", res.data.data.country_id);
              }
              if (res.data.data.currency_name) {
                localStorage.setItem(
                  "currency_name",
                  res.data.data.currency_name
                );
              }
              if (res.data.data.currency_symbol) {
                localStorage.setItem(
                  "currency_symbol",
                  res.data.data.currency_symbol
                );
                store.commit(
                  "setCurrencySymbol",
                  res.data.data.currency_symbol
                );
              }
              if (res.data.data.user_id) {
                localStorage.setItem("userId", res.data.data.user_id);
              }
              nextTick(() => {
                // 如果redirect参数中有值
                if (router.currentRoute.value.query.redirect) {
                  let queryRedirectPath =
                    router.currentRoute.value.query.redirect;
                  router.replace({
                    path: queryRedirectPath,
                  });
                } else {
                  router.replace({
                    path: "/home",
                  });
                }
              });
            } else {
              loginLoading.value = false;
              if (res.data.msg === "Username can't find") {
                loginAccountRef.value.focus();
              }
              if (res.data.msg === "Please enter the correct password") {
                loginPasswordRef.value.focus();
              }
              ElNotification({
                title: "Tips",
                message: res.data.msg,
                type: "warning",
              });
            }
          });
        } else {
          loginPasswordRef.value.focus();
          ElNotification({
            title: "Tips",
            message: "Please input a password",
            type: "warning",
          });
        }
      } else {
        loginAccountRef.value.focus();
        ElNotification({
          title: "Tips",
          message: "Please enter your email address",
          type: "warning",
        });
      }
    };
    return {
      loginLoading,
      loginAccountRef,
      loginPasswordRef,
      userLogin,
      ...toRefs(state),
    };
  },
});
</script>

<style lang="less" scoped>
.login-container {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-image: url("../../assets/images/login_register_forgot_bg.png");
  background-repeat: no-repeat;
  background-position: left top;
  background-size: cover;
  .header-container {
    position: fixed;
    width: 100%;
    height: 80px;
    top: 0;
    left: 0;
    .header-content {
      height: 100%;
      margin: 0 100px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      color: #ffffff;
      .header-logo {
        font-size: 20px;
        font-weight: 500;
        a {
          color: #ffffff;
        }
      }
      .header-menu {
        .header-menu-item {
          .el-dropdown-link {
            cursor: pointer;
            display: flex;
            align-items: center;
            color: #ffffff;
          }
        }
      }
      .header-login-register {
        display: flex;
        align-items: center;
        .header-btn-login {
          margin-right: 40px;
        }
        .header-btn-register {
          padding: 10px 25px;
          border-radius: 10px;
          background-color: #03004d;
          cursor: pointer;
        }
        a {
          color: #ffffff;
        }
      }
    }
  }
  .login-content {
    width: 420px;
    min-width: 420px;
    padding: 64px;
    background-color: #ffffff;
    border-radius: 12px;
    .login-form {
      :deep(.el-form-item) {
        margin-bottom: 10px;
      }
      :deep(.el-form-item__label) {
        padding: 0;
        color: #000000;
      }
    }
  }
  .forgot-password {
    text-align: right;
    a {
      color: #2dbf38;
    }
  }
  .login-btn-login {
    width: 100%;
    margin-top: 70px;
    margin-bottom: 10px;
    background-color: #03004d;
    border-radius: 10px;
    font-size: 18px;
    color: #ffffff;
  }
  .login-register {
    span {
      a {
        color: #2dbf38;
      }
    }
  }
}
</style>
